import React from 'react';
import {List,ListItem,ListItemIcon, ListItemText} from '@mui/material';
import FolderIcon from '@mui/icons-material/Folder';
import styled from "styled-components";

const StyledList = styled(List)`
        width: 100%;
    `

const StyledListItem = styled(ListItem)`
        border-bottom: 1px solid #a8a8a8;
    `

const StyledTitle = styled.h1`
        font-size: 24px;
        text-align: left;
        font-weight: normal;
    `
const Img = styled.img`
    width: 24px;
`

const GapiFetchItemsList = ({items, onFolderClick, handleFileClick}) => {
    return (
        <StyledList>
            <StyledTitle>サンプル株式会社　to　DriveConnector</StyledTitle>
            {
                items.map(item => (
                <StyledListItem
                    button
                    key={item.id}
                    onClick={() => {handleFileClick(item.id)}}
                >
                    <ListItemIcon>
                        {
                            item?.mineType &&
                                item.mimeType === 'application/msword' ||
                                item.mimeType === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ||
                                item.mimeType === 'application/vnd.google-apps.document'?
                                    <Img src={`${process.env.PUBLIC_URL}/img/documents.png`} alt=""/>
                                    :
                                    item.mimeType === 'application/vnd.ms-excel' ||
                                    item.mimeType === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
                                    item.mimeType === 'application/vnd.google-apps.spreadsheet' ?
                                        <Img src={`${process.env.PUBLIC_URL}/img/excel.png`} alt=""/>
                                        :
                                        item.mimeType === 'application/pdf' ?
                                            <Img src={`${process.env.PUBLIC_URL}/img/pdf.png`} alt=""/>
                                            :
                                            item.mimeType === 'application/vnd.google-apps.folder' ?
                                                <FolderIcon></FolderIcon>
                                                :
                                                <Img src={`${process.env.PUBLIC_URL}/img/file.png`} alt=""/>
                        }
                    </ListItemIcon>
                    <ListItemText primary={item.name}/>

                </StyledListItem>
            ))}
        </StyledList>
    );
};

export default GapiFetchItemsList;